import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '@services/user/user.service';

export interface DialogData {
  username: string;
}

@Component({
  selector: 'app-opendialog-send-mail-password',
  templateUrl: './opendialog-send-mail-password.component.html',
  styleUrls: ['./opendialog-send-mail-password.component.scss'],
})
export class OpendialogSendMailPasswordComponent implements OnInit {
  send = false;
  constructor(
    public dialogRef: MatDialogRef<OpendialogSendMailPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private userService: UserService
  ) {}

  ngOnInit(): void {}

  sendMailPassword(): void {
    this.userService.sendPasswordUser(this.data.username).subscribe({
      next: () => {
        this.send = true;

        setTimeout(() => {
          this.dialogRef.close();
        }, 3000);
      },
    });
  }
}
